import {
  findSettingsSectionBySlug,
  SETTINGS_SECTIONS,
  settingsSectionHref
} from '@/components/settings-shell/settings-sections';
import { navigation } from '@/navigation';

/** True for `root` itself and every path below it, never for a longer sibling (`/invoicesx`). */
function isUnder(pathname: string, root: string): boolean {
  return pathname === root || pathname.startsWith(`${root}/`);
}

/**
 * Where to land in another client when switching from `pathname`: the root of the same section.
 * Procurement lands on documents, since whether the next client routes it is unknown here.
 */
export function clientSwitchTarget(pathname: string): string {
  // Receipt detail lives outside `/invoices` but belongs to the invoice list.
  if (isUnder(pathname, navigation.invoices()) || isUnder(pathname, '/receipts')) {
    return navigation.invoices();
  }
  if (isUnder(pathname, navigation.documents())) return navigation.documents();
  if (pathname === navigation.openQuestions()) return navigation.openQuestions();
  if (isUnder(pathname, navigation.settings())) {
    // A section on its own routes (Firmy, Integrace) lands on its root, never on a record.
    const ownRoutes = SETTINGS_SECTIONS.find(
      section => 'path' in section && isUnder(pathname, section.path())
    );
    if (ownRoutes) return settingsSectionHref(ownRoutes);
    // The section, never its query: a step or a filter belongs to the client left behind.
    const section = findSettingsSectionBySlug(pathname.slice(`${navigation.settings()}/`.length));
    return navigation.settings(section?.slug);
  }
  return navigation.documents();
}
